import { Component } from '@angular/core';
import { NavController, NavParams, ModalController } from 'ionic-angular';
import * as Highcharts from 'highcharts';
import * as _ from 'lodash';

import { Data } from '../../providers/providers';
import { Location } from '../../models/location';
import { Irrigation } from '../../providers/providers';
import { AboutIrrigationRecordsPage } from "../about-irrigation-records/about-irrigation-records";
import {LocationIrrigationPage} from "../location-irrigation/location-irrigation";

@Component({
  selector: 'page-location-irrigation-record-list',
  templateUrl: 'location-irrigation-record-list.html'
})
export class LocationIrrigationRecordListPage {

  location: Location;

  Highcharts = Highcharts;

  public showColumns: any[];
  public exportColumns: any[];

  constructor(public navCtrl: NavController,
              public modalCtrl: ModalController,
              public navParams: NavParams,
              public data: Data,
              public irrigation: Irrigation)
  {
    this.location = this.navParams.get('location');

    this.showColumns = [
      'date',
      'water_balance_daily',
      'water_balance_cumulative',
      // 'orchard_et_gpa',
      // 'orchard_et_cumulative',
      // 'rainfall_in',
      // 'rainfall_gpa',
      // 'rainfall_cumulative',
      'irrigation',
      'irrigation_cumulative',
      // 'irrigation_time'
        'irrigation_recommendation',
    ];

    this.exportColumns = [
      {field: 'date', header: 'date'},
      {field: 'orchard_et_gpa', header: 'orchard_et_gpa'},
      {field: 'orchard_et_cumulative', header: 'orchard_et_cumulative'},
      {field: 'rainfall_gpa', header: 'rainfall_gpa'},
      {field: 'rainfall_cumulative', header: 'rainfall_cumulative'},
      {field: 'rainfall_edited', header: 'rainfall_edited'},
      {field: 'irrigation', header: 'irrigation'},
      {field: 'irrigation_cumulative', header: 'irrigation_cumulative'},
      {field: 'irrigation_edited', header: 'irrigation_edited'},
      {field: 'water_balance_daily', header: 'water_balance_daily'},
      {field: 'water_balance_cumulative', header: 'water_balance_cumulative'},
      {field: 'irrigation_recommendation', header: 'irrigation_recommendation'}
    ];
  }

  columnSelected(cols) {
    return _.some(this.showColumns, (col) => _.indexOf(cols, col) != -1);
  }

  howManyColumnsSelected(cols) {
    let val = 0;
    for (let col of this.showColumns) {
      if (_.indexOf(cols, col) != -1) {
        val += 1;
      }
    }
    return val;
  }

  ngAfterViewInit() {
    this.irrigation.setLocation(this.location);
  }

  ngOnDestroy() {
  }

  openAbout() {
    this.navCtrl.push(AboutIrrigationRecordsPage, {});
  }

  goToModel() {
    this.navCtrl.pop();
    this.navCtrl.push(LocationIrrigationPage, {location: this.location});
  }
}



// WEBPACK FOOTER //
// ./src/pages/location-irrigation-record-list/location-irrigation-record-list.ts